// dopa-welcome-modal.js
(function() {
  window.DOPA = window.DOPA || {};
  window.DOPA.openWelcomeModal = initWelcomeModal;
  return;

  function initWelcomeModal() {
    // Prevent multiple initializations
    if (document.getElementById('dopa-welcome-modal')) return;

    const html = `
      <div class="dopa-wm-overlay" id="dopa-welcome-overlay">
        <div class="dopa-wm-modal" id="dopa-welcome-modal">
          <button class="dopa-wm-close" id="dopa-wm-close" aria-label="Đóng">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="2"><line x1="1" y1="1" x2="13" y2="13"></line><line x1="13" y1="1" x2="1" y2="13"></line></svg>
          </button>
          
          <div id="dopa-wm-content">
            <div class="dopa-wm-header">
              <div class="dopa-wm-icon">👋</div>
              <h2 class="dopa-wm-title">Ưu đãi đơn hàng đầu tiên</h2>
              <p class="dopa-wm-desc">Ưu đãi giảm <span class="dopa-wm-highlight">10%</span> cho đơn đầu tiên & kích hoạt tích luỹ 5% vào ví DopeCredit của bạn.</p>
            </div>
            
            <form id="dopa-wm-form" class="dopa-wm-form">
              <div class="dopa-wm-field">
                <label class="dopa-wm-label" for="dopa-wm-phone">Số điện thoại của bạn</label>
                <input type="tel" id="dopa-wm-phone" class="dp-input dopa-wm-input" autocomplete="tel" placeholder="0xxxxxxxxx" required>
              </div>
              <button type="submit" class="dopa-ui-btn dopa-ui-btn--primary w-100" id="dopa-wm-submit">Nhận ưu đãi khách mới</button>
              <p class="dopa-wm-footnote">Đồng hành cùng các Bác sĩ, Điều dưỡng và Kỹ thuật viên tại các bệnh viện trên khắp cả nước</p>
              <div class="dopa-wm-error" id="dopa-wm-error"></div>
            </form>
          </div>

          <div id="dopa-wm-success-view" class="dopa-wm-success">
            <div class="dopa-wm-success-icon">🎉</div>
            <h3>Thiết lập thành công!</h3>
            <p>Tuyệt vời, mã giảm 10% sẽ <strong>tự động áp dụng</strong> khi bạn thanh toán.</p>
            <p style="margin-top: 12px;">Hãy chọn cho mình bộ đồng phục ưng ý nhé.</p>
            <button class="dopa-ui-btn dopa-ui-btn--primary w-100" style="margin-top: 24px;" onclick="document.getElementById('dopa-welcome-overlay').classList.remove('dopa-wm-active')">Bắt đầu mua sắm</button>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', html);
    
    // Force reflow
    const overlay = document.getElementById('dopa-welcome-overlay');
    void overlay.offsetWidth;
    overlay.classList.add('dopa-wm-active');

    // Event listeners
    document.getElementById('dopa-wm-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });

    document.getElementById('dopa-wm-form').addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const phoneInput = document.getElementById('dopa-wm-phone').value;
      const errorEl = document.getElementById('dopa-wm-error');
      const submitBtn = document.getElementById('dopa-wm-submit');
      
      const phone = phoneInput.replace(/[^0-9+]/g, '');
      if (phone.length < 9) {
        showError('Vui lòng nhập số điện thoại hợp lệ.');
        return;
      }

      errorEl.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Đang xử lý...';

      try {
        const apikey = (window.DOPA_CONFIG && window.DOPA_CONFIG.supabaseAnonKey) || (window.dopaConfig && window.dopaConfig.supabaseKey) || '';
        const url = (window.DOPA_CONFIG && window.DOPA_CONFIG.supabaseUrl) ? `${window.DOPA_CONFIG.supabaseUrl}/functions/v1/dopa-auth` : 'https://xosmuewauiyvlcjdrklk.supabase.co/functions/v1/dopa-auth';
        
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${apikey}`, 'apikey': apikey },
          body: JSON.stringify({ action: 'save-lead', phone: phone })
        });
        
        const data = await res.json();
        
        if (data.success) {
          // Success!
          localStorage.setItem('dopa_welcome_seen', 'true');
          // Update global state if fast-checkout uses it
          localStorage.setItem('dopa_fc_session', JSON.stringify({ phone: phone, credit: 0 }));
          
          document.getElementById('dopa-wm-content').style.display = 'none';
          document.getElementById('dopa-wm-success-view').style.display = 'block';
        } else {
          showError(data.error || 'Có lỗi xảy ra, vui lòng thử lại.');
          submitBtn.disabled = false;
          submitBtn.textContent = 'Kích hoạt đặc quyền';
        }
      } catch (err) {
        showError('Lỗi kết nối. Vui lòng kiểm tra lại mạng.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Kích hoạt đặc quyền';
      }
    });

    function showError(msg) {
      const el = document.getElementById('dopa-wm-error');
      el.textContent = msg;
      el.style.display = 'block';
    }

    function closeModal() {
      overlay.classList.remove('dopa-wm-active');
      localStorage.setItem('dopa_welcome_seen', 'true'); // mark seen even if closed without submitting
      setTimeout(() => {
        if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      }, 300);
    }
  }
})();
